/**
 *简体中文语言包
 */
export const LANGUAGE = {
  guanbi: "关闭",
  fanhui: "返回",
  rengong:"人工",
  rgkf: "人工客服",
  fqxdlthh: "发起新的聊天会话",
  tjwt: "提交问题",
  tjcg: "提交成功",
  wtms: "问题描述",
  hfnr: "回复内容",
  tjhf: "提交回复",
  wjhf: "玩家回复",
  sbppxh: "设备品牌型号",
  sbxtbb: "设备系统版本",
  email: "邮箱",
  wjjwt: "未解决问题",
  yjjwt: "已解决问题",
  qsrhfnr: "请输入回复内容",
  ssgjc: "请输入搜索关键词",
  faqcjwt: "常见问题",
  qsrwtms: "请输入问题描述",
  qmsnyddwt: "请描述您遇到的问题!",
  xuantian: "选填",
  loadling: "加载中...",
  ltjldzljs: "聊天记录到这里结束",
  error1: "回复内容不能为空！",
  error2: "回复内容不超过150个字",
  error3: "orderid获取失败!",
  error4: "邮箱格式不正确!",
  error5: "获取数据失败，请稍后尝试。如尝试有问题，请联系客服！",
  error6: "目前没有相关数据，如有疑问联系客服!",
  error7: "很抱歉如果没能解决你的问题，请继续发送消息!",
  yhxy: "用户协议",
  yscl: "隐私策略",
  wjfk: "玩家反馈",
  xuanze: "选择",
  fwq:"服务器",
  yxzh:"角色名称",
  tishiyu: "咨询账号登入，卡顿，黑屏等无法正常进行游戏相关问题时，请务必留下您的设备信息。提供完善的信息，将有助于我们更加快速的解决您的问题",
  ssjg: "搜索结果",
  kfgzts: "客服工作时间为09:00-00:00 (UTC+8),我们会在工作时间内尽快回复您!",
}



// WEBPACK FOOTER //
// ./src/language/zh.js